export default __webpack_public_path__ + "static/media/app-icon.aac704d9.svg";